








import Vue from "vue";
import { mapMutations } from "vuex";
import _ from "lodash";
import getUnit from "@/helpers/get-unit.ts";

export default Vue.extend({
  data: () => ({
    unit: ""
  }),

  computed: {
    capitalizedUnit() {
      return _(this.unit).capitalize();
    },

    symbol() {
      return `°${this.unit[0].toUpperCase()}`;
    }
  },

  created() {
    this.setTitle("Settings");
  },

  mounted() {
    this.unit = getUnit();
  },

  methods: {
    ...mapMutations(["setTitle"]),

    changeUnit() {
      this.unit = this.unit === "celsius" ? "fahrenheit" : "celsius";
      localStorage.setItem("unit", this.unit);
    }
  }
});
